import SectionIndustries from './SectionIndustries';

export default SectionIndustries;
